"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarkdownImage;
var _react = _interopRequireDefault(require("react"));
/*:: // 

import { type Node } from 'react';*/
/*:: type Props = {
  url?: string,
  title?: string,
  alt?: string
};*/
function MarkdownImage(props /*: Props*/) /*: Node*/{
  var title = props.title,
    url = props.url,
    alt = props.alt;
  return /*#__PURE__*/_react.default.createElement("img", {
    src: url,
    title: title,
    alt: alt
  });
}
MarkdownImage.displayName = 'MarkdownImage';
//# sourceMappingURL=Image.js.map